<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Contratos ativos</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Relatórios Contratos Ativos</a>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card gp-report-card">
                            <div class="card-body">
                                <div class="row gp-report-filters">
                                    <div class="col-md-4 col-lg-4" v-if="User.garid == 0">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <v-autocomplete v-model="GarantidoraSelected" :items="Garantidoras" item-title="garNomeEmpresa" item-value="garId"
                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhum registro encontrado" @update:model-value="BuscaImobiliarias()" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="User.garid == 0 || User.tpeid == 1">
                                        <div class="form-group">
                                            <label>Imobiliaria</label>
                                            <v-autocomplete v-model="ImobiliariaSelected" :items="Imobiliarias" item-title="imoNomeEmpresa" item-value="imoId"
                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhum registro encontrado" @update:model-value="BuscaCliente()" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4"
                                        v-if="User.garid == 0 || User.tpeid == 1 || User.tpeid == 3">
                                        <div class="form-group">
                                            <label>Cliente</label>
                                            <v-autocomplete v-model="ClienteSelected" :items="Clientes"
                                                item-title="nomeConcatenado" item-value="cliId" density="compact" variant="outlined"
                                                :placeholder="ImobiliariaSelected ? 'Digite para pesquisar' : 'Selecione a imobiliária'"
                                                :disabled="!ImobiliariaSelected" clearable hide-details
                                                no-data-text="Nenhum cliente encontrado" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Data Inicial</label>
                                            <input v-model="DataIncial" type="date" class="form-control"
                                                placeholder="Data Inicial" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Data Final</label>
                                            <input v-model="DataFinal" type="date" class="form-control"
                                                placeholder="Data Final" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <button type="button" class="btn btn-info"
                                            style="color:#ffffff;margin-top: 35px;" @click="Pesquisar()">
                                            Pesquisar
                                        </button>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <a href="#" @click="EditCancel()" class="btn btn-link"
                                            style="margin-top: 35px;">Cancelar</a>
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px;padding-bottom: 20px;">
                                    <hr>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="d-flex align-items-center">
                                            <h4 class="card-title">Resultado</h4>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" md="6" style="text-align: right;padding-right: 15px;">
                                                <button @click="exportXLSX()" class="btn btn-warning">Exportar CSV</button>
                                            </v-col>
                                        </v-row>
                                        <div class="gp-report-total" v-if="ListResult.length">
                                            <span>Valor total filtrado</span>
                                            <strong>R$ {{ formatarValor(totalValorContratos) }}</strong>
                                        </div>
                                        <adm-data-table :headers="headers" :items="ListResult" v-model="itemsSelected" :show-filters="false" :show-export="true"
                                            :export-headers="headersExportacao" file-name="contratos-ativos"
                                            alternating theme-color="#364f66" table-class-name="customize-table"
                                            header-text-direction="center" body-text-direction="center"
                                            rows-per-page-message="Linhas por pagina">
                                            <template #item-imobiliariaResumo="item">
                                                <div class="gp-report-entity"><strong>{{ item.imobNome }}</strong><small>{{ item.DocumentoImobiliaria }}</small></div>
                                            </template>
                                            <template #item-clienteResumo="item">
                                                <div class="gp-report-entity"><strong>{{ item.cliNome }}</strong><small>{{ item.cliDocumento }}</small></div>
                                            </template>
                                            <template #item-pdiDataVigenciaIni="item">
                                                <span> {{ item.pdiDataVigenciaIni !== null ?
                                                    formattedDate(item.pdiDataVigenciaIni) : null }}</span>
                                            </template>
                                            <template #item-pdiDataVigenciaFim="item">
                                                <span> {{ item.pdiDataVigenciaFim !== null ?
                                                    formattedDate(item.pdiDataVigenciaFim) : null }}</span>
                                            </template>
                                            <template #item-pedValorTotalPedido="item">
                                                <span> {{ item.pedValorTotalPedido !== null ?
                                                    formatarValor(item.pedValorTotalPedido) : null }}</span>
                                            </template>
                                            <!--template #item-actions="item">
                                                <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;"
                                                    variant="text">
                                                    <v-icon class="editiconcor">mdi-</v-icon>
                                                    <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                                </v-btn>
                                            </!--template-->
                                        </adm-data-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import EasyDataTable from 'vue3-easy-data-table'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import moment from 'moment'
import * as XLSX from 'xlsx'

export default {
  name: 'RelatorioContratosAtivosView',
  components: {
    EasyDataTable,
    moment
  },
  data: () => ({
    User: {
      garid: 0,
      tpeid: 0,
      pesid: 0
    },
    editor: DecoupledEditor,
    GarantidorasGeral: [],
    Garantidoras: [],
    GarantidoraSelected: null,
    ImobiliariasGeral: [],
    Imobiliarias: [],
    ImobiliariaSelected: null,
    ClientesGeral: [],
    Clientes: [],
    ClienteSelected: null,
    DataIncial: '',
    DataFinal: '',
    searchValue: '',
    itemsSelected: [],
    ListResult: [],
    ListPedidosGeral: [],
    ListPedidosGeralFiltro: [],
    ListaPedidoItem: [],
    headers: [],
    headersExportacao: []
  }),
  methods: {
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    EditGrid (item) {

    },
    EditCancel () {
      this.$router.go(0)
    },
    montaGrid () {
      this.headers = []
      this.headersExportacao = []
      if (this.User.garid == 0) {
        this.headers.push({ text: 'Garantidora', value: 'NomeGarantidora', sortable: true })
        this.headersExportacao.push({ text: 'Garantidora', value: 'NomeGarantidora' })
      }
      this.headers.push({ text: 'Imobiliária', value: 'imobiliariaResumo', sortable: true })
      this.headers.push({ text: 'Cliente', value: 'clienteResumo', sortable: true })
      this.headers.push({ text: 'Contratação', value: 'pedId', sortable: true })
      this.headers.push({ text: 'Pacote', value: 'pdiNomeProduto', sortable: true })
      this.headers.push({ text: 'Valor', value: 'pedValorTotalPedido', sortable: true })
      this.headers.push({ text: 'Inicial', value: 'pdiDataVigenciaIni', sortable: true })
      this.headers.push({ text: 'Final', value: 'pdiDataVigenciaFim', sortable: true })
      this.headersExportacao.push(
        { text: 'Imobiliária', value: 'imobNome' },
        { text: 'Documento Imobiliária', value: 'DocumentoImobiliaria' },
        { text: 'Cliente', value: 'cliNome' },
        { text: 'Documento Cliente', value: 'cliDocumento' },
        { text: 'Contratação', value: 'pedId' },
        { text: 'Pacote', value: 'pdiNomeProduto' },
        { text: 'Valor', value: 'pedValorTotalPedido' },
        { text: 'Inicial', value: 'pdiDataVigenciaIni' },
        { text: 'Final', value: 'pdiDataVigenciaFim' }
      )
    },
    GarantidoraEdit (Value) {
      this.Garantidoras = this.GarantidorasGeral.filter(x => x.garId == Value)
      this.GarantidoraSelected = Value
      this.BuscaImobiliarias()
    },
    BuscaImobiliarias () {
      if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
        this.ImobiliariaSelected = null
        this.ImobiliariasGeral = []
        this.Imobiliarias = []
        axios.get('/Telas/RelatorioContratosAtivos/GetByGarIdParIdImobiliarias/' + this.GarantidoraSelected + '/0')
          .then(response => {
            if (response.data.length > 0) {
              this.ImobiliariasGeral = response.data.sort((a, b) =>
                a.imoNomeEmpresa.localeCompare(
                  b.imoNomeEmpresa,
                  'pt',
                  { sensitivity: 'base' }
                )
              )
              this.Imobiliarias = this.ImobiliariasGeral
            }
          })
      } else {
        this.ImobiliariaSelected = null
        this.ImobiliariasGeral = []
        this.Imobiliarias = []
        this.ClienteSelected = null
        this.ClientesGeral = []
        this.Clientes = []
      }
    },
    BuscaCliente () {
      if (this.ImobiliariaSelected != '' && this.ImobiliariaSelected != null) {
        this.ClienteSelected = null
        this.ClientesGeral = []
        this.Clientes = []
        axios.get('/Telas/RelatorioContratosAtivos/GetByGarIdImoIdClientes/0/' + this.ImobiliariaSelected)
          .then(response => {
            this.ClientesGeral = response.data.filter(x => x.cliAtivo) // consumidor
            this.Clientes = this.ClientesGeral.map(item => {
              return {
                ...item,
                nomeConcatenado: `${item.cliId} - ${item.cliNomeEmpresa} - ${item.cliDocumento}`
              }
            })
          })
      } else {
        this.ClienteSelected = null
        this.ClientesGeral = []
        this.Clientes = []
      }
    },
    async Pesquisar () {
      // Validação: DataFinal não pode ser menor que DataIncial
      if (this.$moment(this.DataFinal).isBefore(this.$moment(this.DataIncial))) {
        this.$mensagemAviso('Data Final não pode ser menor que Data Inicial!')
        return
      }

      // Define os parâmetros para a consulta
      const _garId = this.GarantidoraSelected || 0
      const _tpeid = this.ImobiliariaSelected ? 3 : 0
      const _pesid = this.ImobiliariaSelected || 0

      try {
        // Consulta os pedidos
        const response = await axios.get(
                    `/Telas/RelatorioContratosAtivos/GetAllValorTotal/${_garId}/${_tpeid}/${_pesid}`
        )
        // Filtra para pegar somente os pedidos com situação "Vigente"
        this.ListPedidosGeral = response.data.filter(
          (x) => x.pedSituacaoPedido === 'Vigente'
        )

        // Mapeia os pedidos para incluir informações adicionais
        this.ListPedidosGeralFiltro = this.ListPedidosGeral.map((pedido) => {
          // Busca a garantidora correspondente pelo garId
          const garantidora = this.GarantidorasGeral.find((g) => g.garId === pedido.garId)
          // Busca a imobiliária correspondente pelo imobId
          const imobiliaria = this.ImobiliariasGeral.find((i) => i.imoId === pedido.imobId)

          return {
            ...pedido,
            NomeGarantidora: garantidora ? garantidora.garNomeEmpresa : 'Não encontrada',
            DocumentoImobiliaria: imobiliaria ? imobiliaria.imoDocumento : 'Não encontrada',
            imobiliariaResumo: `${pedido.imobNome || ''} ${imobiliaria ? imobiliaria.imoDocumento : ''}`.trim(),
            clienteResumo: `${pedido.cliNome || ''} ${pedido.cliDocumento || ''}`.trim(),
            pdiNomeProduto: null, // Inicializa como null
            pdiDataVigenciaIni: null,
            pdiDataVigenciaFim: null
          }
        })

        // Para cada pedido, busca os itens e atualiza os campos (usa Promise.all para aguardar todas as chamadas)
        await Promise.all(
          this.ListPedidosGeralFiltro.map(async (element) => {
            try {
              const responseItem = await axios.get(
                '/Telas/RelatorioContratosAtivos/GetAllByPedIdItem/' + element.pedId
              )
              if (responseItem.data.length > 0) {
                const primeiroItem = responseItem.data[0] // Usa apenas o primeiro item
                element.pdiNomeProduto = primeiroItem.pdiNomeProduto
                element.pdiDataVigenciaIni = primeiroItem.pdiDataVigenciaIni
                element.pdiDataVigenciaFim = primeiroItem.pdiDataVigenciaFim
              }
            } catch (error) {
              console.error('Erro ao buscar itens para o pedido ' + element.pedId, error)
            }
          })
        )

        // Inicia o filtro com a lista completa
        let filtered = [...this.ListPedidosGeralFiltro]

        // Aplica o filtro por Cliente, se selecionado
        if (this.ClienteSelected != null && this.ClienteSelected !== '') {
          filtered = filtered.filter((x) => x.cliId == this.ClienteSelected)
        }

        // Aplica o filtro por data (usando pedDataPedido) se ambos os campos estiverem preenchidos
        if (this.DataFinal !== '' && this.DataIncial !== '') {
          // Converte os filtros para objetos Date
          const dataInicio = new Date(this.DataIncial)
          const dataFinal = new Date(this.DataFinal)
          // Ajusta o final do dia para incluir todo o dia
          dataFinal.setHours(23, 59, 59, 999)

          filtered = filtered.filter((x) => {
            // Se a data do pedido estiver ausente, ignora o registro
            if (!x.pedDataPedido) {
              console.error('Data inválida para o registro:', x)
              return false
            }
            const dataRegistro = new Date(x.pedDataPedido)
            if (isNaN(dataRegistro.getTime())) {
              console.error('Data inválida para o registro:', x.pedDataPedido)
              return false
            }
            return dataRegistro >= dataInicio && dataRegistro <= dataFinal
          })
        }

        // Ordenação final: ordena por NomeGarantidora, imobNome, cliId e pdiDataVigenciaIni
        // (caso nenhum filtro seja aplicado, ou mesmo após os filtros, essa ordenação garante a consistência)
        this.ListResult = filtered.sort((a, b) => {
          return (
            a.NomeGarantidora.localeCompare(b.NomeGarantidora) ||
                        a.imobNome.localeCompare(b.imobNome) ||
                        (a.cliId - b.cliId) ||
                        (new Date(a.pdiDataVigenciaIni) - new Date(b.pdiDataVigenciaIni))
          )
        })

        // console.log("this.ListPedidosGeralFiltro", this.ListPedidosGeralFiltro);
        // console.log("this.ListResult", this.ListResult);
      } catch (error) {
        console.error(error)
      }
    },
    exportCSV () {
      if (this.ListResult.length === 0) {
        alert('Não há dados para exportar.')
        return
      }

      // Criar cabeçalho CSV
      const csvHeader = this.headers.map(h => h.text).join(';') + '\n'

      // Criar linhas do CSV
      const csvRows = this.ListResult.map(item => {
        const columns = []
        if (this.User.garid == 0) {
          columns.push(item.NomeGarantidora)
        }
        columns.push(item.imobNome)
        columns.push(item.DocumentoImobiliaria)
        columns.push(item.cliNome)
        columns.push(item.cliDocumento)
        columns.push(item.pedId)
        columns.push(item.pdiNomeProduto)
        columns.push(item.pedValorTotalPedido)
        columns.push(item.pdiDataVigenciaIni)
        columns.push(item.pdiDataVigenciaFim)

        return columns.join(';')
      }).join('\n')

      // Criar conteúdo CSV final
      const csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + csvHeader + csvRows

      // Criar link de download
      const encodedUri = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'RelatorioContratosAtivos.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    exportXLSX () {
      if (!this.ListResult || this.ListResult.length === 0) {
        alert('Não há dados para exportar.')
        return
      }

      const includeGarantidora = this.User?.garid === 0

      // Cabeçalhos
      const headers = [
        ...(includeGarantidora ? ['Garantidora'] : []),
        'Imobiliária',
        'Documento Imobiliária',
        'Cliente',
        'Documento Cliente',
        'Pedido',
        'Produto',
        'Valor Total',
        'Vigência Início',
        'Vigência Fim'
      ]

      // Helpers ----------------------------------------------------
      const toNumber = (v) => {
        if (v === null || v === undefined || v === '') return null
        if (typeof v === 'number') return v
        const s = String(v).replace(/\./g, '').replace(',', '.')
        const n = parseFloat(s)
        return isNaN(n) ? null : n
      }

      const DATE_FORMATS = [
        'YYYY-MM-DDTHH:mm:ss',
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD'
      ]

      // Converte para serial do Excel (meia-noite UTC)
      const toExcelSerial = (v) => {
        if (!v) return null
        const m = this.$moment.utc(v, DATE_FORMATS, true)
        if (!m.isValid()) return null
        const mMid = m.startOf('day')
        const excelEpoch = this.$moment.utc('1899-12-30', 'YYYY-MM-DD', true)
        return mMid.diff(excelEpoch, 'days', true) // número
      }
      // ------------------------------------------------------------

      // Linhas (chaves = rótulos)
      const rows = this.ListResult.map(item => {
        const row = {}
        if (includeGarantidora) row.Garantidora = item.NomeGarantidora ?? ''
        row['Imobiliária'] = item.imobNome ?? ''
        row['Documento Imobiliária'] = item.DocumentoImobiliaria ?? ''
        row.Cliente = item.cliNome ?? ''
        row['Documento Cliente'] = item.cliDocumento ?? ''
        row.Pedido = item.pedId ?? ''
        row.Produto = item.pdiNomeProduto ?? ''
        row['Valor Total'] = toNumber(item.pedValorTotalPedido)
        row['Vigência Início'] = toExcelSerial(item.pdiDataVigenciaIni)
        row['Vigência Fim'] = toExcelSerial(item.pdiDataVigenciaFim)
        return row
      })

      // Worksheet
      const ws = XLSX.utils.json_to_sheet(rows, { header: headers, skipHeader: false })

      // Larguras
      ws['!cols'] = [
        ...(includeGarantidora ? [{ wch: 28 }] : []),
        { wch: 28 }, // Imobiliária
        { wch: 22 }, // Doc Imobiliária
        { wch: 28 }, // Cliente
        { wch: 22 }, // Doc Cliente
        { wch: 10 }, // Pedido
        { wch: 28 }, // Produto
        { wch: 14 }, // Valor Total
        { wch: 14 }, // Vigência Início
        { wch: 14 } // Vigência Fim
      ]

      // Formatação: número e datas
      const ref = ws['!ref']
      if (ref) {
        const range = XLSX.utils.decode_range(ref)
        const idx = (label) => headers.indexOf(label)
        const colValor = idx('Valor Total')
        const colDtIni = idx('Vigência Início')
        const colDtFim = idx('Vigência Fim')

        for (let r = range.s.r + 1; r <= range.e.r; r++) {
          if (colValor >= 0) {
            const a = XLSX.utils.encode_cell({ c: colValor, r })
            const c = ws[a]
            if (c && typeof c.v === 'number') {
              c.t = 'n'
              c.z = '#,##0.00'
            }
          }
          // Datas: já são números (seriais). Só aplicar formato.
          if (colDtIni >= 0) {
            const a = XLSX.utils.encode_cell({ c: colDtIni, r })
            const c = ws[a]
            if (c && typeof c.v === 'number' && c.v > 0) {
              c.t = 'n'
              c.z = 'dd/mm/yyyy'
            }
          }
          if (colDtFim >= 0) {
            const a = XLSX.utils.encode_cell({ c: colDtFim, r })
            const c = ws[a]
            if (c && typeof c.v === 'number' && c.v > 0) {
              c.t = 'n'
              c.z = 'dd/mm/yyyy'
            }
          }
        }

        ws['!autofilter'] = { ref }
      }

      // Workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Contratos Ativos')
      XLSX.writeFile(wb, 'RelatorioContratosAtivos.xlsx', { compression: true })
    },
    async Get () {
      await axios.get('/Telas/RelatorioContratosAtivos/GetDados')
        .then(response => {
          this.GarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
            a.garNomeEmpresa.localeCompare(
              b.garNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )
          this.User.tpeid = response.data.tpeId
          this.User.garid = response.data.garId
          this.User.pesid = response.data.pesId

          this.ImobiliariasGeral = response.data.imobiliarias.sort((a, b) =>
            a.imoNomeEmpresa.localeCompare(
              b.imoNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )

          if (this.User.garid == 0) {
            this.EditView = false
            this.Garantidoras = this.GarantidorasGeral
          } else {
            this.GarantidoraEdit(this.User.garid)
          }
          this.montaGrid()
        })
    }
  },
  created () {
    this.Get()
  },
  computed: {
    totalValorContratos () {
      return (this.ListResult || []).reduce((total, item) =>
        total + (Number(item.pedValorTotalPedido) || 0), 0)
    }
  }
}
</script>

<style></style>
